module.exports = __webpack_public_path__ + "static/img/7.ba48e2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7.jpg
// module id = 327
// module chunks = 0